import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import SoftwareProductsPage from "@/pages/products/SoftwareProductsPage";

export const Route = createFileRoute("/products/software")({
  head: () => pageHead("Custom Agentic Software", "Custom agentic software engineering for your workflows, data, and enterprise integrations, with governed tool use, human oversight, evaluation, and monitoring.", "/products/software", false),
  component: SoftwareProductsPage,
});
